import type { HTMLAttributes, ReactNode } from "react";

interface Props extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function Card({ children, className = "", ...rest }: Props) {
  return (
    <div
      {...rest}
      className={`bg-card border border-border rounded-2xl p-6 ${className}`}
    >
      {children}
    </div>
  );
}
